import axios from 'axios';
import { getApiUrl } from '@/config/api';
import authService from '@/shared/services/auth';

class CatImpuestoService {
  constructor() {
    this.impuestos = [];
    this.loading = false;
    this.error = null;
    this.selectedEmpresa = null;
  }

  async initialize() {
    // Esperar un poco para que la empresa se seleccione
    await this.waitForEmpresa();
    await this.listar();
  }

  // Esperar a que la empresa esté seleccionada
  async waitForEmpresa() {
    let attempts = 0;
    const maxAttempts = 50; // 5 segundos máximo
    
    while (attempts < maxAttempts) {
      this.selectedEmpresa = authService.getSelectedEmpresa();
      if (this.selectedEmpresa && this.selectedEmpresa.EmpresaId) {
        console.log('Empresa encontrada para CatImpuesto:', this.selectedEmpresa);
        return;
      }
      
      // Esperar 100ms antes del siguiente intento
      await new Promise(resolve => setTimeout(resolve, 100));
      attempts++;
    }
    
    // Si no se encuentra empresa después de los intentos
    this.error = 'No se pudo obtener la empresa seleccionada';
    console.error('No se pudo obtener empresa para CatImpuesto después de', maxAttempts, 'intentos');
  }

  async listar() {
    this.loading = true;
    this.error = null;
    
    try {
      // Verificar que tenemos empresa seleccionada
      if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
        this.selectedEmpresa = authService.getSelectedEmpresa();
        if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
          this.loading = false;
          return { success: false, data: [], message: 'Debe elegir una empresa antes de poder continuar.' };
        }
      }

      const token = authService.getToken();
      const response = await axios.post(getApiUrl('/api/CatImpuesto/listar'), {
        EmpresaId: this.selectedEmpresa.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      
      // Filtrar por empresa en el frontend como medida de seguridad adicional
      const allImpuestos = response.data || [];
      this.impuestos = allImpuestos.filter(impuesto => impuesto.EmpresaId === this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Impuestos cargados:', this.impuestos.length, 'de', allImpuestos.length, 'total');
      console.log('Empresa del usuario:', this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Impuestos cargados:', this.impuestos.length);
      
      return {
        success: true,
        data: this.impuestos,
        message: 'Impuestos cargados exitosamente'
      };
    } catch (error) {
      console.error('Error al cargar Impuestos:', error);
      this.error = error.message;
      this.impuestos = [];
      this.loading = false;
      throw error;
    }
  }

  async guardar(impuestoData) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...impuestoData,
        EmpresaId: selectedEmpresa?.EmpresaId || impuestoData.EmpresaId
      };

      const response = await axios.post(getApiUrl('/api/CatImpuesto/guardar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Impuesto guardado exitosamente'
      };
    } catch (error) {
      console.error('Error al guardar Impuesto:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al guardar Impuesto'
      };
    }
  }

  async borrar(impuestoData) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...impuestoData,
        EmpresaId: selectedEmpresa?.EmpresaId || impuestoData.EmpresaId
      };

      const response = await axios.post(getApiUrl('/api/CatImpuesto/borrar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Impuesto eliminado exitosamente'
      };
    } catch (error) {
      console.error('Error al eliminar Impuesto:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al eliminar Impuesto'
      };
    }
  }

  async lectura(clave) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatImpuesto/lectura'), {
        Clave: clave,
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error al leer Impuesto:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al leer Impuesto'
      };
    }
  }

  async recargar() {
    await this.listar();
  }

  async downloadBulk() {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatImpuesto/descarga-masiva'), {
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      });

      // Crear enlace de descarga
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `impuestos_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return {
        success: true,
        message: 'Descarga iniciada correctamente'
      };
    } catch (error) {
      console.error('Error al descargar Impuestos:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al descargar Impuestos'
      };
    }
  }
}

export default CatImpuestoService;
